import React from 'react'
import { motion } from 'framer-motion'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { CreditCard, Receipt, ArrowRight } from 'lucide-react'

const SuccessMessage = ({ handlePayment, handleGoToOrders }) => {
    return (
        <motion.div
            className="space-y-8 py-8 max-w-md mx-auto"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
        >
            {/* Icône de succès animée avec Framer Motion */}
            <motion.div
                className="flex flex-col items-center justify-center space-y-4"
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
            >
                <div className="relative">
                    <motion.div
                        className="w-32 h-32 bg-primary/10 rounded-full flex items-center justify-center"
                        animate={{
                            scale: [1, 1.05, 1],
                            opacity: [0.7, 1, 0.7]
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                    >
                        <motion.div
                            className="w-24 h-24 bg-primary/20 rounded-full flex items-center justify-center"
                            animate={{
                                scale: [1, 1.1, 1],
                                opacity: [0.6, 1, 0.6]
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: 0.1
                            }}
                        >
                            <motion.div
                                className="w-16 h-16 bg-primary/60 rounded-full flex items-center justify-center"
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{
                                    delay: 0.5,
                                    duration: 0.5,
                                    type: "spring",
                                    stiffness: 200
                                }}
                            >
                                <CheckCircleIcon className="h-full w-full text-white" />
                            </motion.div>
                        </motion.div>
                    </motion.div>

                    {/* Points ping animés */}
                    <motion.div
                        className="absolute -top-1 -right-1 w-6 h-6 bg-primary rounded-full"
                        animate={{
                            scale: [1, 2, 1],
                            opacity: [1, 0, 1]
                        }}
                        transition={{
                            duration: 1,
                            repeat: Infinity,
                            ease: "easeOut"
                        }}
                    />
                    <motion.div
                        className="absolute -bottom-1 -left-1 w-4 h-4 bg-primary rounded-full"
                        animate={{
                            scale: [1, 2, 1],
                            opacity: [1, 0, 1]
                        }}
                        transition={{
                            duration: 1,
                            repeat: Infinity,
                            ease: "easeOut",
                            delay: 0.2
                        }}
                    />
                </div>

                {/* Titre avec gradient */}
                <motion.h3
                    className="text-2xl font-bold text-center bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.8 }}
                >
                    Commande créée avec succès !
                </motion.h3>

                {/* Description */}
                <motion.p
                    className="text-center text-base-content/70 leading-relaxed"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1 }}
                >
                    Votre commande a été enregistrée. Cliquez sur <strong className="text-primary">"Procéder au paiement"</strong> pour finaliser votre achat en toute sécurité.
                </motion.p>
            </motion.div>

            {/* Boutons d'action */}
            <motion.div
                className="flex flex-col gap-4 justify-center mt-8"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2 }}
            >
                <motion.button
                    className="btn btn-primary btn-lg w-full gap-2 shadow-lg hover:shadow-xl transition-all duration-200"
                    onClick={handlePayment}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                >
                    <CreditCard className="w-5 h-5" />
                    Procéder au paiement
                    <ArrowRight className="w-4 h-4" />
                </motion.button>

                <motion.button
                    className="btn btn-outline btn-primary w-full gap-2"
                    onClick={handleGoToOrders}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1.4 }}
                >
                    <Receipt className="w-4 h-4" />
                    Voir mes commandes
                </motion.button>
            </motion.div>

          
        </motion.div>
    )
}

export default SuccessMessage